import { render, staticRenderFns } from "./FilterGroupForm.vue?vue&type=template&id=1a77fe10"
import script from "./FilterGroupForm.vue?vue&type=script&lang=js"
export * from "./FilterGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports